import { useQuery } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import {
  getTermsNotices,
  TERMS_TYPE_LABEL,
  type TermsTargetRole,
} from "~/services/common/terms";

interface Props {
  targetRole: TermsTargetRole;
  className?: string;
}

/**
 * 약관 개정 고지 배너.
 *
 * 시행일이 아직 오지 않았고 고지 시작일이 지난 약관을 알린다.
 * (불리한 변경은 시행 30일 전, 일반 변경은 7일 전 고지가 원칙 — 고지 시작일은 어드민에서 지정)
 * 비로그인 상태에서도 보여야 해서 인증 없는 API 를 쓴다.
 */
export function TermsNoticeBanner({ targetRole, className }: Props) {
  const { history } = useRouter();

  const { data } = useQuery({
    queryKey: ["terms-notices", targetRole],
    queryFn: () => getTermsNotices(targetRole),
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

  const notice = data?.[0];
  if (!notice) return null;

  const more = (data?.length ?? 0) - 1;

  return (
    <button
      type="button"
      onClick={() =>
        history.push(
          `/policy?type=${notice.termsType}&seq=${notice.id}`,
        )
      }
      className={`flex items-center gap-2 px-3 py-2.5 w-full text-left rounded-xl bg-amber-50 ${className ?? ""}`}
    >
      <span className="text-sm">📢</span>
      <span className="min-w-0 flex-1">
        <span className="block text-xs font-bold text-amber-800">
          {TERMS_TYPE_LABEL[notice.termsType]} 개정 안내
          {more > 0 && ` 외 ${more}건`}
        </span>
        <span className="block text-[11px] text-amber-700">
          {notice.effectiveAt?.slice(0, 10)} 시행 예정 · 눌러서 내용 확인
        </span>
      </span>
      <span className="text-xs text-amber-700 shrink-0">›</span>
    </button>
  );
}

export default TermsNoticeBanner;
